import { Button } from "@progress/kendo-react-buttons";
import { Avatar, Card, CardBody, CardHeader, CardSubtitle } from "@progress/kendo-react-layout";
import "./LoginScreen.css";

const LoginScreen = () => {
  const handleSamlLogin = () => {
    const currentUrl = window.location.href;
    window.location.href = `${
      process.env.REACT_APP_API_ENDPOINT
    }/auth/saml/login?returnUrl=${encodeURIComponent(currentUrl)}`;
  };

  return (
    <div className="login-screen">
      <div className="left-side">
        <Card className="login-card">
          <CardHeader className="login-screen-header">
            <Avatar
              shape="square"
              type="image"
              className="login-avatar"
              size={"large"}
            ></Avatar>
            <h2>Atlas Login</h2>
          </CardHeader>
          <CardBody className="login-screen-body">
            <CardSubtitle>Sign In With</CardSubtitle>
            <br />
            <Button
              primary="true"
              onClick={handleSamlLogin}
              className="login-button"
              size={"small"}
            >
              <br />
              <br />
            </Button>
          </CardBody>
        </Card>
      </div>
      <div className="right-side"></div>
    </div>
  );
};

export default LoginScreen;
